import request from '@/js/request'
// 获取错误模具列表
export function getWarning (data) {
  return request({
    url: '/alert',
    method: 'get',
    params: data
  })
}
